import gql from 'graphql-tag'

const clientList = gql`query GetClientLogos {
  client {
    displayText
    logo {
      urls
    }
    showOnHomepage
    siteLink
  }
}`

const caseStudyThumbnail = gql`query GetCaseStudyLogos {
  client {
    displayText
    alias {
      alias
    }
    logoThumbnail {
      urls
    }
    flow {
      contentItems {
        ... on StatBlock {
          latest
        }
        ... on ContentBlock {
          latest
        }
        ... on Buttons {
          latest
        }
        ... on Image {
          latest
        }
      }
    }
  }
}`

const caseStudyList = gql`query GetCaseStudyList {
  client {
    displayText
    subtitle
    alias {
      alias
    }
    thumbnailImage {
      urls
    }
    primaryColour
    caseStudyQuote {
      contentItems {
        ... on ContentBlock {
          contentBlockTitle
          contentBlockSubtitle
          markdownBody {
            html
          }
        }
      }
    }
    flow {
      contentItems {
        ... on StatBlock {
          latest
        }
        ... on ContentBlock {
          latest
        }
        ... on Buttons {
          latest
        }
        ... on Image {
          latest
        }
      }
    }
  }
}`

const caseStudy = gql`query GetCaseStudy($alias: String!) {
  client(where: {alias: {alias: $alias}}) {
    displayText
    subtitle
    bannerImage {
      urls
    }
    logo {
      urls
    }
    caseStudyQuote {
      contentItems {
        ... on ContentBlock {
          contentBlockTitle
          contentBlockSubtitle
          markdownBody {
            html
          }
        }
      }
    }
    siteLink
    primaryColour
    flow {
      contentItems {
        ... on ClientStats {
          bag {
            contentItems {
              ... on StatBlock {
                displayText
                statQuantity
              }
            }
          }
          backgroundImage {
            urls
          }
        }
        ... on ContentBlockFlowpart {
          displayText
          contentBlockSubtitle
          markdownBody {
            html
          }
          image {
            urls
          }
          imagePosition
        }
        ... on Carousel {
          displayText
          textColour
          slides {
            contentItems {
              ... on CarouselSlide {
                displayText
                slideCopy {
                  html
                }
                subtitle
                image {
                  urls
                }
                imagePosition
              }
            }
          }
        }
        ... on ProjectHeader {
          displayText
          markdownBody {
            html
          }
          backgroundImage {
            urls
          }
          backgroundColour
          textColour
        }
      }
    }
  }
}`

export {
  clientList,
  caseStudyThumbnail,
  caseStudyList,
  caseStudy
}